class CtxActions {
  constructor() {
    this.generateActions(
      'update'
    );
  }
}

export default CtxActions;



// WEBPACK FOOTER //
// ./app/flux/actions/Ctx.js